import { jwtDecode } from 'jwt-decode';

import { getUserToken } from './user-hash';

interface IClientJwtPayload {
  uuid?: string;
  clientUuid?: string;
  client_uuid?: string;
  sub?: string;
}

export const getClientUuidFromToken = (): string | null => {
  const { accessToken } = getUserToken();

  return getClientUuidFromAccessToken(accessToken);
};

export const getClientUuidFromAccessToken = (
  accessToken: string
): string | null => {
  if (!accessToken) {
    return null;
  }

  try {
    const payload = jwtDecode<IClientJwtPayload>(accessToken);

    return (
      payload.uuid ??
      payload.clientUuid ??
      payload.client_uuid ??
      payload.sub ??
      null
    );
  } catch {
    return null;
  }
};
